import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { LookupModel } from '../../models/common/lookup.model';
import { MediaCategory } from '../../models/media/media-category.model';
import { MediaGroup } from '../../models/media/media-group.model';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { SettingsService } from '../../services/settings.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from '../../shared-new/services/toast.service';

@Component({
  selector: 'app-media-category-popup',
  templateUrl: './media-category-popup.component.html',
  styleUrls: ['./media-category-popup.component.scss']
})
export class MediaCategoryPopupComponent extends BaseUnsubscribeComponent implements OnInit {
  @Input() public data: any;
  public isLoader: boolean;
  public mediaGroups: MediaGroup[];
  form: FormGroup;
  constructor(private readonly settingService: SettingsService, public readonly modal: NgbActiveModal, private httpErrorHandlerService: HttpErrorHandlerService,
    private readonly toastService: ToastService) {
      super();
  }

  ngOnInit(): void {
    this.settingService.getMediaGroups().pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.mediaGroups = response;
    });
    const mediaCategory: MediaCategory = this.data?.category as MediaCategory;
    this.form = MediaCategory.asFormGroup(mediaCategory);
  }
  closePopup(): void {
    this.modal.close(JSON.stringify(this.data));
  }
  public submitForm(formData: any): void {
    let mediaCategory = formData as MediaCategory;
    mediaCategory.id = this.data?.category?.id;
    this.settingService.saveMediaCategory(mediaCategory).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.toastService.success("Category Saved!", "Categories");
      this.closePopup();
    }, (err) => {
      if (err) {
        this.httpErrorHandlerService.ShowErrorMessage(err);
      }
    })
  }
}
